import React, { useState, useEffect } from 'react';
import { dataApi } from "../../apis/dataApi";
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import '../../css/fonts.css'
import '../../css/style.css'
import '../../css/bootstrap@5.3.0.min.css'
import bg from '../../assets/Walpapers/Wallpaper.png';
import kidzos from '../../assets/Iconos/kidzos.png';
import card from '../../assets/Iconos/card.png';
import { useTranslation } from 'react-i18next';
import LogoCam from '../../assets/Logotipo/Logo_cetesninos_color.png';
import { useNavigate } from 'react-router-dom';


function Inversiones() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState("");

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const b = searchParams.get("b");
    const [investments, setInvestments] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    //const code = searchParams.get('code');
    const [code, setCode] = useState('');

    useEffect(() => {
        
        setIsLoading(true);

        dataApi.getToken().then((response) => {
            console.log("PARTE 1");
            console.log(response);
            if (response.isSuccess) {

                dataApi.getKidInfoBracelet(response.token, b).then((userResponse) => {
                    console.log("PARTE 1B USER");
                    console.log(userResponse);
                    if (userResponse.isSuccess) {
                        setUserInfo(userResponse.userData);
                    }else{
                        toast.error('Brazalete no encontrado.');
                        setIsLoading(false);
                    }
                });

                console.log("PARTE 2");
                dataApi.GetTodayInvestments(response.token, b).then((visitorReponse) => {
                    console.log("PARTE 3");
                    console.log(visitorReponse);
                    if (visitorReponse.isSuccess) {
                        setInvestments(visitorReponse.items);
                        setIsLoading(false);
                    } else {
                        toast.error('Brazalete no encontrado.');
                    }
                });
            } else {
                dataApi.getToken().then((responseInner) => {
                });
            }
            console.log(response)
        }).catch((error) => {
            console.error('Error:', error);
        });
    }, [b]);

    const handleClick = (e) => {
        e.preventDefault();
        navigate(`/`);
    }

    return (
        <div className="cetes-background" style={{ backgroundImage: `url(${bg})` }}>
            <div className="cetes-background-inner">
                <div className="cetes-junior-header">
                    <div className="info-header-cetes-junior">
                        <div className="text-header-cetes">
                            <h4 className="text-header-mayus">{t('resumen_title')}<b>{t('resumen_title_bold')}</b></h4>
                        </div>
                    </div>
                    <div className="logo_CETES_junior">
                        <div className="logo logo-cetes">
                            <img src={LogoCam} alt="Logo organización KidZania" />
                        </div>
                    </div>
                </div>
                <div class="">
                    <div class="item-ttl white-color">
                        <h4 style={{ textAlign: "left" }}>{t('resumen_title_name')}: <b>{userInfo}</b></h4>
                    </div>
                </div>
                <div className="registro-content_">
                    <table className='tbl_resumen'>
                        <thead>
                            <tr>
                                <th>{t('resumen_columna_folio')}</th>
                                <th>{t('resumen_columna_fecha')}</th>
                                <th>{t('resumen_columna_inv_inicial')}</th>
                                <th>{t('resumen_columna_hora_inicio')}</th>
                                <th>{t('resumen_columna_hora_fin')}</th>
                                <th>{t('resumen_columna_tiempo')}</th>
                                <th>{t('resumen_columna_inv_final')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(investments) && investments.length > 0 ? (
                                investments.map((inv, idx) => (
                                    inv.tiempoInversion != "20" ?
                                    <tr key={idx}>
                                        <td>{inv.folio}</td>
                                        <td>{inv.fecha}</td>
                                        <td>{inv.inversionInicial} kidZos</td>
                                        <td>{inv.horaInicio}</td>
                                        <td>{inv.horaFin}</td>
                                        <td>{inv.tiempoInversion} min.</td>
                                        <td>{inv.inversionFinal} kidZos</td>
                                    </tr>
                                    : ""
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={7} style={{ textAlign: 'center' }}>No hay inversiones</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="registro-form-cetes-inner">
                    <div className="btn-cetesJunior" >
                        <button type="submit" onClick={handleClick} style={{ float: 'right' }}>{t('resumen_columna_finalizar')} </button>
                    </div>
                </div>
            </div>
            {isLoading ? (
                <div className="loading">
                    <div className="spinner"></div>
                </div>
            ) : (
                <div>
                    {/* Resto del código */}
                </div>
            )}
        </div>
    );
}



export default Inversiones;